export const ERROR_MESSAGE = {
    "User validation failed: phoneNumber: Please provide a valid phone number":
      "Please provide a valid phone number",
  };

 